
import FilterRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/FilterRequest";
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import IFilterModel from "@models/IFilterModel";
import EventBus from "@models/eventBus";
import PaginationResponseT from "@/api/dataSource/api/Common/ResponseModels/PaginationResponseT";
import PaginationRequest from "@/api/dataSource/api/Common/RequestModels/PaginationRequest";
import {
  isPaginatedListResponse,
  readPaginationCount,
  readPaginationItems,
} from "@/utils/pagination";

@Component
export default class CustomTableComponent extends Vue {
  @Prop({ required: false, type: Object }) filter: IFilterModel;
  @Prop({ default: true }) pagination: boolean;
  @Prop({ default: false, type: Boolean }) noSaveFilter: boolean;
  @Prop({ default: false, type: Boolean }) noClearBtn: boolean;
  @Prop({ required: true }) getDataFunc: (
    req?: Object
  ) =>
    | Promise<PaginationResponseT<Object>>
    | ((req?: Object) => Promise<Object[]>);
  @Prop() removeFunc: (id: number) => Promise<boolean>;
  @Prop({ required: true }) templateColumns: string;
  @Prop({ required: true }) columnNames: string[];
  @Prop({ default: 10, type: Number }) pageSize: number;
  @Inject("eventBus") eventBus: EventBus;
  entitiesCount = 0;
  request: FilterRequest = null;
  get page(): number {
    const take = this.request.Pagination.Take || this.pageSize;
    return this.request.Pagination.Skip / take + 1;
  }
  set page(v: number) {
    const take = this.request.Pagination.Take || this.pageSize;
    this.request.Pagination.Skip = (v - 1) * take;
  }
  get hasActiveFilterSlot():boolean{
     return Boolean(this.$slots["filter"]); 
  }
  isLoading = false;
  items: any[] = [];
  constructor() {
    super();
  }
  async fetchData() {
    this.isLoading = true;
    try {
      const filter =
        this.filter == null || this.filter.toFilterRequest == null
          ? null
          : this.filter.toFilterRequest();
      if (filter) {
        delete filter.Pagination;
        delete filter.Sort;
      }
      Object.assign(this.request, filter || {});

      const res = await this.getDataFunc(this.request);
      if (!this.noSaveFilter) this.saveFilter();

      if (this.pagination && isPaginatedListResponse(res)) {
        this.items = readPaginationItems(res);
        this.entitiesCount = readPaginationCount(res);
      } else if (Array.isArray(res)) {
        this.items = res;
        this.entitiesCount = res.length;
      } else {
        this.items = [];
        this.entitiesCount = 0;
      }
      this.$forceUpdate();
    } catch (error) {
      this.items = [];
      this.entitiesCount = 0;
      this.$notification.error((error || {}).ErrorMessage || error);
    } finally {
      this.isLoading = false;
    }
  }
  async created() {
    this.request = new FilterRequest({
      Pagination: this.pagination
        ? new PaginationRequest({
            Skip: 0,
            Take: this.pageSize,
          })
        : null,
    });
    this.restoreFilter();
    await this.fetchData();
    this.eventBus.deleteEntity.on(this.deleteHandler);
  }
  saveFilter() {
    var dataName = `filter-data-${this.$route.name}`;
    var data = JSON.stringify(this.request);
    localStorage.setItem(dataName, data);
  }
  restoreFilter() {
    if (this.filter == null || this.noSaveFilter) {
      return;
    }
    var dataName = `filter-data-${this.$route.name}`;
    var dataJson = localStorage.getItem(dataName);
    if (!dataJson) return;
    var data = JSON.parse(dataJson);
    Object.assign(this.request, data);
    if (typeof (this.filter as any).restoreFromFilterRequest === "function") {
      (this.filter as any).restoreFromFilterRequest(data);
      return;
    }
    Object.assign(this.filter, data);
  }
  beforeDestroy() {
    this.eventBus.deleteEntity.removeListener(this.deleteHandler);
  }
  async deleteHandler(data: { id: number }) {
    const res = await this.$dialog.confirm(
      `Вы действительно хотите удалить сущность с ИД: ${data.id}?`
    );  
    if (!res) return;
    this.isLoading = true;

    await this.removeFunc(data.id).then(res => {
      if(res) {    
      this.fetchData();
      }
    }).catch(error => {
      this.$notification.error(error)    
      this.isLoading = false;
    })
    // const serverRes = await this.removeFunc(data.id);    
    // if (serverRes) {
    //   await this.fetchData();
    // } else {
    //     this.isLoading = false;
    //   }
  }
  resetPagination() {
    if (this.pagination) this.page = 1;
  }
  onSearch(request: FilterRequest) {
    const filterRequest: any = { ...(request || {}) };
    delete filterRequest.Pagination;
    delete filterRequest.Sort;
    Object.assign(this.request, filterRequest);
    this.resetPagination();
    this.fetchData();
  }
  onPaginationChange(p: { Page: number; CountOnPage: number }) {
    const take = p.CountOnPage || this.pageSize;
    this.request.Pagination.Take = take;
    this.request.Pagination.Skip = (p.Page - 1) * take;
    this.fetchData();
  }
}
